import { render, staticRenderFns } from "./indexNom.vue?vue&type=template&id=f4cdff98&scoped=true&"
import script from "./indexNom.vue?vue&type=script&lang=js&"
export * from "./indexNom.vue?vue&type=script&lang=js&"
import style0 from "./indexNom.vue?vue&type=style&index=0&id=f4cdff98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cdff98",
  null
  
)

export default component.exports